export const IS_ACTIVE = 'is--active';
export const IS_STICKY = 'is--sticky';
export const IS_HIDDEN = 'is--hidden';
export const IS_VALID = 'is--valid';
export const ACTIVATED = 'activated';
export const IS_DISABLED_MOBILE = 'is--disabled-mobile';
export const IS_ERROR = 'is--error';
